







































import {Vue, Component, Prop } from 'vue-property-decorator';
import DisableIcon from "./DisableIcon.vue";
import EnableIcon from "./EnableIcon.vue";
import PlusIcon from "./PlusIcon.vue";

@Component({
    name: 'MeetingSlotActions',
    components: { DisableIcon, EnableIcon, PlusIcon }
})
export default class MeetingSlotActions extends Vue {
    @Prop({ default: false }) isNotAvailable: boolean;
    @Prop({ default: false }) isAdmin: boolean;
    @Prop({ default: false }) isSpeaker: boolean;
    @Prop({ default: false }) isMine: boolean;
    @Prop({ default: false }) isBusy: boolean;

    showUserSelect(event: MouseEvent) {
        this.$emit('showUserSelect', event)
    }

    disable(event: MouseEvent) {
        this.$emit('disable')
    }

    enable(event: MouseEvent) {
        this.$emit('enable')
    }

    get enableTitle() {
        if(this.isAdmin || this.isSpeaker) {
            return this.$t('meetings.slot.unlock');
        }
        else {
            return this.$t('meetings.slot.take');
        }
    }

    get disableTitle() {
        if(this.isAdmin || this.isSpeaker) {
            return this.$t('meetings.slot.block');
        }
        else {
            return this.$t('meetings.slot.freeUp');
        }
    }

    get isBusyForAdmin() {
        return this.isAdmin && !this.isNotAvailable && this.isBusy;
    }

    get showEnable() {
        if(this.isAdmin || this.isSpeaker) {
            return this.isNotAvailable;
        }
        else {
            return !this.isNotAvailable && !this.isMine
        }
    }

    get disableClass() {
        return "meeting-slot-actions__disable"
    }

    get enableClass() {
        return "meeting-slot-actions__enable"
    }
}

